<template>
<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="18" cy="18" r="17.5" transform="rotate(-180 18 18)" stroke="currentColor"/>
<g clip-path="url(#clip0_2424_12270)">
<path d="M14.9682 15.2754H12.25V23.9423H14.9682V15.2754Z" fill="currentColor"/>
<path d="M22.3135 15.0825C22.2108 15.0712 22.1056 15.0631 21.9986 15.0587C20.477 14.9967 19.6166 15.8997 19.3198 16.2848C19.2409 16.3881 19.2014 16.4544 19.2014 16.4544V15.2948H16.6016V23.9616H19.3198V19.8896C19.3198 19.3017 19.2741 18.673 19.5684 18.1389C19.8176 17.6874 20.2678 17.4613 20.7775 17.4613C22.2785 17.4613 22.3141 18.8195 22.3141 18.9485V24.0011H25.0324V18.348C25.0324 16.4137 24.0493 15.2697 22.3141 15.0825H22.3135Z" fill="currentColor"/>
<path d="M13.6073 14.1522C14.4778 14.1522 15.1834 13.4465 15.1834 12.5761C15.1834 11.7056 14.4778 11 13.6073 11C12.7369 11 12.0312 11.7056 12.0312 12.5761C12.0312 13.4465 12.7369 14.1522 13.6073 14.1522Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2424_12270">
<rect width="13" height="13" fill="white" transform="translate(12.0312 11)"/>
</clipPath>
</defs>
</svg>
</template>